import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { hasSchemaACL } from '@frontend/auth-helpers';
import { useAppScopeStore, useScopedAppFlagStore } from '@frontend/scope';

export const useBulkMessagingAcls = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const hasEmailSettingsAccess = !!selectedLocationIds.find((locationId) =>
    hasSchemaACL(locationId, Permission.EMAIL_SETTINGS_MANAGE)
  );
  const hasEmailMarketingAccess = !!selectedLocationIds.find((locationId) =>
    hasSchemaACL(locationId, Permission.EMAIL_MARKETING_MANAGE)
  );

  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const hasDomainVerifyAccess = getFeatureFlagValue('domain-verify-settings');

  const hasBulkMessagingAccess = hasEmailSettingsAccess || hasEmailMarketingAccess || hasDomainVerifyAccess;

  return { hasBulkMessagingAccess, hasEmailSettingsAccess, hasEmailMarketingAccess, hasDomainVerifyAccess };
};
